import { FC } from "react";
import classNames from "classnames";

import InputField from "../InputField/InputField.tsx";
import { InputFieldAuthProps } from "./types.ts";

import styles from "./InputFieldAuth.module.css";



const InputFieldAuth: FC<InputFieldAuthProps> = ({ className, ...props }) => {
  return (
    <InputField
      classNameWrapper={classNames(styles.field, className)}
      className={styles.field__input}
      classNameError={styles.field__error}
      {...props}
    />
  );
};

export default InputFieldAuth;
